import {Outlet} from "react-router-dom";
import * as React from "react";
import LoggedInNavigation from "./../components/Navigations/LoggedInNavigation";
import {Col, Container, Row} from "react-bootstrap";
import Footer from "./../components/Footer";

function HomeLayout({ backgroundColor = "#fff"}) {
	return (
		<div style={{backgroundColor}} className="d-flex flex-column min-vh-100">
			<LoggedInNavigation />
			<div className="flex-grow-1">
				<Outlet/>
			</div>
			<Footer className="bg-dark-blue"/>
		</div>

);
}

export default HomeLayout;
